"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.promiseDeprecatedError = void 0;

require("core-js/modules/es.promise.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.splice.js");

var _constants = require("./constants");

var promiseDeprecatedError = 'the promise is deprecated by race condition';
exports.promiseDeprecatedError = promiseDeprecatedError;

var genRaceQueue = function genRaceQueue(deprecatedError) {
  var errorFlag = deprecatedError || _constants.promiseDeprecated;
  var raceQueue = [];
  return {
    push: function push(p, customerErrorFlag) {
      var _raceQueue, _raceQueue2;

      if (!(p instanceof Promise)) {
        throw new Error('The race queue item should be Promise');
      }

      var flag = customerErrorFlag || errorFlag;

      if (raceQueue && raceQueue[0]) {
        raceQueue[0][flag] = true;
      }

      (_raceQueue = raceQueue) === null || _raceQueue === void 0 ? void 0 : _raceQueue.splice(0);
      (_raceQueue2 = raceQueue) === null || _raceQueue2 === void 0 ? void 0 : _raceQueue2.push(p);
      return p;
    },
    clear: function clear(customerErrorFlag) {
      var _raceQueue3;

      var flag = customerErrorFlag || errorFlag;

      if (raceQueue && raceQueue[0]) {
        raceQueue[0][flag] = true;
      }

      (_raceQueue3 = raceQueue) === null || _raceQueue3 === void 0 ? void 0 : _raceQueue3.splice(0);
    },
    destroy: function destroy(customerErrorFlag) {
      var _raceQueue4;

      var flag = customerErrorFlag || errorFlag;

      if (raceQueue && raceQueue[0]) {
        raceQueue[0][flag] = true;
      }

      (_raceQueue4 = raceQueue) === null || _raceQueue4 === void 0 ? void 0 : _raceQueue4.splice(0);
      raceQueue = null;
    },
    __UNSAFE__getQueue: function __UNSAFE__getQueue() {
      return raceQueue;
    }
  };
};

var _default = genRaceQueue;
exports.default = _default;